import gql from 'graphql-tag';

import { logger } from '#src/lib/logger';

import { selectParams } from '../../../store/location/selectors';
import { requireAuthentication, showNotFoundInPlace } from '../guards.js';

export const path = '/games/:gameId/host-voice-notes';
export const component = 'GameSettings';

export const query = gql`
  query GameSettingsAccess($gameId: Int!) {
    game(id: $gameId, type: falkor) {
      ... on FalkorGame {
        id
        superchargerMessaging {
          canEdit
        }
      }
    }
  }
`;

// Only an admin, the game's own designated sms host, or a whitelisted
// calendar editor can save here - wb-notify-service decides that (the
// whitelist lives in its env), so ask it via canEdit and show everyone
// else a 404 rather than an editor whose Save is always refused.
export const thunk =
  ({ graphqlClient } = {}) =>
  async (dispatch, getState) => {
    if (requireAuthentication(dispatch, getState)) return;

    const gameId = Number(selectParams(getState()).gameId) || null;
    let canEdit = false;

    if (gameId) {
      try {
        const { data } = await graphqlClient.query({
          query,
          fetchPolicy: 'network-only',
          variables: { gameId },
        });
        canEdit = !!data?.game?.superchargerMessaging?.canEdit;
      } catch (error) {
        logger.error('[game-settings] failed to check edit access', error);
      }
    }

    if (!canEdit) await showNotFoundInPlace(dispatch, getState);
  };
